<template>

</template>

<script>
export default {
  name: "Recruit"
}
</script>

<style scoped>

</style>